<script lang="ts">
	import { nbspify } from "../../../core/utils/nbspify.js";
	import ServicePage from "../components/ServicePage.svelte";
	import type { ServiceLogisticsProps } from "./ServiceLogisticsProps.js";
	import logistics1 from "../assets/images/logisticke-reseni-1.jpg?webp&w=1920&imagetools";
	import logistics2 from "../assets/images/logisticke-reseni-2.jpg?webp&w=1920&imagetools";
	import logistics3 from "../assets/images/logisticke-reseni-3.jpg?webp&w=1920&imagetools";
	import logistics4 from "../assets/images/logisticke-reseni-4.jpg?webp&w=1920&imagetools";

	type $$Props = ServiceLogisticsProps;

	const { references, blogPosts } = $$restProps as $$Props;

	const images = [logistics1, logistics2, logistics3, logistics4];

	const heading = "Navrhneme logistické řešení \n pro každý sklad";
	const title =
		"Naše poradenské služby v oblasti skladování \n a logistiky jsou navrženy tak, aby vám pomohly optimalizovat vaše skladové prostory a procesy.";
	const perex =
		"BITO skladovací technika nabízí komplexní podporu od počátečního návrhu \n až po finální realizaci skladových systémů.";
	const perex2 =
		"Náš tým odborníků analyzuje vaše aktuální skladové potřeby a doporučí nejvhodnější řešení, \n které zlepší efektivitu, využití prostoru a zrychlí manipulaci s materiálem.";
</script>

<ServicePage {heading} {title} {perex} {perex2} {images} {references} {blogPosts}>
	<div class="mb-32 flex flex-col items-center gap-14">
		<p class="text-center text-lg font-bold text-gray-400 lg:text-xl">
			{nbspify("Co naše poradenská")}
			<br />
			{nbspify("služba zahrnuje?")}
		</p>
		<div class="grid grid-cols-1 gap-y-5 px-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
			<div class="w-[17rem]">
				<span class="font-quicksand group-hover:text-tertiary text-gray text-[4.375rem] leading-[3.3rem]">1</span>
				<div class="mt-4 flex flex-col">
					<div class="border-gray flex h-[16rem] flex-col gap-4 border p-6 md:border-r-0">
						<p class="text-primary text-md font-extrabold">{nbspify("Analýza skladového prostoru")}</p>
						<p class="text-bito-black">
							{nbspify("Detailní posouzení aktuálních dispozic vašeho skladu, včetně zhodnocení procesů a potřeb.")}
						</p>
					</div>
				</div>
			</div>

			<div class="w-[17rem]">
				<span class="font-quicksand group-hover:text-tertiary text-gray text-[4.375rem] leading-[3.3rem]">2</span>
				<div class="mt-4 flex flex-col">
					<div class="border-gray flex h-[16rem] flex-col gap-4 border p-6 lg:border-r-0">
						<p class="text-primary text-md font-extrabold">{nbspify("Individuální návrh řešení")}</p>
						<p class="text-bito-black">
							{nbspify(
								"Na základě vaší specifické situace navrhneme optimální uspořádání regálových a skladovacích systémů s ohledem na prostor a požadavky na manipulaci.",
							)}
						</p>
					</div>
				</div>
			</div>

			<div class="w-[17rem]">
				<span class="font-quicksand group-hover:text-tertiary text-gray text-[4.375rem] leading-[3.3rem]">3</span>
				<div class="mt-4 flex flex-col">
					<div class="border-gray flex h-[16rem] flex-col gap-4 border p-6 md:border-r-0 lg:border-r xl:border-r-0">
						<p class="text-primary text-md font-extrabold">{nbspify("Optimalizace skladovacích procesů")}</p>
						<p class="text-bito-black">
							{nbspify(
								"Pomůžeme vám zefektivnit procesy vychystávání, skladování a distribuce, což povede k úsporám času a zvýšení produktivity.",
							)}
						</p>
					</div>
				</div>
			</div>

			<div class="w-[17rem]">
				<span class="font-quicksand group-hover:text-tertiary text-gray text-[4.375rem] leading-[3.3rem]">4</span>
				<div class="mt-4 flex flex-col">
					<div class="border-gray flex h-[16rem] flex-col gap-4 border p-6 lg:border-r-0">
						<p class="text-primary text-md font-extrabold">Implementace <br /> a školení</p>
						<p class="text-bito-black">
							{nbspify(
								"Po schválení návrhu zajistíme bezproblémovou implementaci řešení včetně školení vašich zaměstnanců pro efektivní používání nových systémů.",
							)}
						</p>
					</div>
				</div>
			</div>

			<div class="w-[17rem]">
				<span class="font-quicksand group-hover:text-tertiary text-gray text-[4.375rem] leading-[3.3rem]">5</span>
				<div class="mt-4 flex flex-col">
					<div class="border-gray flex h-[16rem] flex-col gap-4 border p-6">
						<p class="text-primary text-md font-extrabold">Servis <br /> a podpora</p>
						<p class="text-bito-black">
							{nbspify(
								"Nabízíme dlouhodobou technickou podporu a servisní služby, aby vaše skladovací systémy zůstaly v perfektním stavu a zajistily vám maximální návratnost investic.",
							)}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</ServicePage>
